import React from 'react';

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const pages = [];
  const visiblePages = 5;
  const ellipsis = '...';

  if (totalPages <= 1) return null;

  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = Math.min(totalPages, startPage + visiblePages - 1);

  if (endPage === totalPages) {
    startPage = Math.max(1, endPage - visiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const pageButtonStyle = {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 4px',
    border: '2px solid #005eb8',
    backgroundColor: 'transparent',
    color: '#005eb8',
    fontSize: '14px',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    textDecoration: 'none',
    outline: 'none',
    userSelect: 'none'
  };

  const activeButtonStyle = {
    ...pageButtonStyle,
    backgroundColor: '#005eb8',
    color: '#ffffff',
    boxShadow: '0 2px 8px rgba(0, 94, 184, 0.3)'
  };

  const hoverStyle = {
    backgroundColor: '#005eb8',
    color: '#ffffff',
    transform: 'scale(1.1)',
    boxShadow: '0 4px 12px rgba(0, 94, 184, 0.2)'
  };

  return (
    <nav 
      aria-label="Page navigation" 
      style={{ 
        padding: '24px 20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '8px'
      }}
    >
      {startPage > 1 && (
        <>
          <button
            type="button"
            onClick={() => handlePageChange(1)}
            style={pageButtonStyle}
            onMouseEnter={(e) => {
              if (currentPage !== 1) {
                Object.assign(e.target.style, hoverStyle);
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== 1) {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#005eb8';
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = 'none';
              }
            }}
            aria-label="Go to first page"
          >
            1
          </button>
          {startPage > 2 && (
            <span style={{
              color: '#4c6272',
              fontSize: '16px',
              fontWeight: 500,
              padding: '0 4px',
              userSelect: 'none'
            }}>
              {ellipsis}
            </span>
          )}
        </>
      )}

      {pages.map((page) => {
        const isActive = currentPage === page;
        return (
          <button
            key={page}
            type="button"
            onClick={() => handlePageChange(page)}
            style={isActive ? activeButtonStyle : pageButtonStyle}
            onMouseEnter={(e) => {
              if (!isActive) {
                Object.assign(e.target.style, hoverStyle);
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#005eb8';
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = 'none';
              }
            }}
            aria-current={isActive ? 'page' : undefined}
            aria-label={`Go to page ${page}`}
          >
            {page}
          </button>
        );
      })}

      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && (
            <span style={{
              color: '#4c6272',
              fontSize: '16px',
              fontWeight: 500,
              padding: '0 4px',
              userSelect: 'none'
            }}>
              {ellipsis}
            </span>
          )}
          <button
            type="button"
            onClick={() => handlePageChange(totalPages)}
            style={pageButtonStyle}
            onMouseEnter={(e) => {
              if (currentPage !== totalPages) {
                Object.assign(e.target.style, hoverStyle);
              }
            }}
            onMouseLeave={(e) => {
              if (currentPage !== totalPages) {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = '#005eb8';
                e.target.style.transform = 'scale(1)';
                e.target.style.boxShadow = 'none';
              }
            }}
            aria-label="Go to last page"
          >
            {totalPages}
          </button>
        </>
      )}
    </nav>
  );
};

export default Pagination;
